import { useState } from 'react';

const useForceUpdate = () => {
  let [value, setState] = useState(true);
  return () => setState(!value);
};

export default useForceUpdate;
